export default __webpack_public_path__ + "efbf84f0f6384f5c303ea15ebb299a08.png";